/**
 * Reasoning effort selector (only for GPT-5).
 */
interface ReasoningEffortSelectorProps {
  value: 'minimal' | 'low' | 'medium' | 'high'
  onChange: (effort: 'minimal' | 'low' | 'medium' | 'high') => void
  disabled?: boolean
}

export const ReasoningEffortSelector: React.FC<ReasoningEffortSelectorProps> = ({
  value,
  onChange,
  disabled = false,
}) => {
  const getDescription = (effort: string) => {
    switch (effort) {
      case 'minimal':
        return 'Fastest response, minimal reasoning (~10-20 sec)'
      case 'low':
        return 'Quick response with basic reasoning (~15-25 sec)'
      case 'medium':
        return 'Balanced quality and speed (recommended, ~20-40 sec)'
      case 'high':
        return 'Best quality, extensive reasoning (~30-60 sec)'
      default:
        return ''
    }
  }

  return (
    <div>
      <label htmlFor="reasoning" className="label">
        Reasoning Effort
        <span className="ml-2 text-xs text-gray-500 font-normal">
          (GPT-5 only)
        </span>
      </label>
      <select
        id="reasoning"
        value={value}
        onChange={(e) => onChange(e.target.value as any)}
        className="select"
        disabled={disabled}
      >
        <option value="minimal">Minimal</option>
        <option value="low">Low</option>
        <option value="medium">Medium (Default)</option>
        <option value="high">High</option>
      </select>
      <p className="text-sm text-gray-600 mt-1">{getDescription(value)}</p>
    </div>
  )
}
